import { defineNuxtRouteMiddleware, navigateTo } from '#app';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { session } = useAuth();
  
  // Wait for session to be loaded
  await new Promise(resolve => setTimeout(resolve, 0));
  
  // Check if user is authenticated and has admin role
  const user = session.value?.user as any;
  const isAdmin = user?.role === 'admin' || user?.email === 'admin@example.com';
    if (!user || !isAdmin) {
    // If not an admin, redirect to home page
    return navigateTo('/');
  }
});
